





























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { Dialog } from 'vant';
import { enumToObject } from '@/utils/util';

enum TypeEnum {
  已评分 = 0,
  待评分 = 1,
  培训中评分 = 2,
}

@Component
export default class TeacherEvaluation extends Vue {
  @Prop() curriculumInfo: any;
  @Prop() type: TypeEnum;

  show: boolean = false;

  showLevelPicker: boolean = false;

  levelValue: string = ''; // 显示的等级string

  columns = [
    {
      // values: enumToObject(models.EvaluationLevel).map(e => e.label),
      values: [
        models.EvaluationLevel[models.EvaluationLevel.优秀],
        models.EvaluationLevel[models.EvaluationLevel.良好],
        models.EvaluationLevel[models.EvaluationLevel.一般],
        models.EvaluationLevel[models.EvaluationLevel.差],
        models.EvaluationLevel[models.EvaluationLevel.较差],
      ],
      defaultIndex: 0,
    },
  ];

  teacherForm: models.TeacherEvaluationDto = {
    classType: null,
    publicTrainingClassId: null,
    className: '',
    trainingSchedulingId: null,
    courseName: '',
    teacherId: null,
    teacherName: '',
    deptId: null,
    storage: '',
    dicValue: null,
    score: 0,
    content: '',
    id: null,
    level: null,
  };

  @Watch('show', { deep: true, immediate: true })
  showChange() {
    this.teacherForm.score = 0;
    if (this.type !== TypeEnum.培训中评分) {
      Object.keys(this.teacherForm).forEach(k => {
        if (k in this.curriculumInfo) this.teacherForm[k] = this.curriculumInfo[k];
      });
      this.teacherForm.teacherName = this.curriculumInfo.teacher;
      this.teacherForm.teacherId = this.curriculumInfo.systemTeacherId;
      this.teacherForm.publicTrainingClassId = this.curriculumInfo.classId;
      if (this.curriculumInfo.level) this.levelValue = models.EvaluationLevel[this.curriculumInfo.level];
    } else {
      Object.keys(this.teacherForm).forEach(k => {
        if (k in this.curriculumInfo) this.teacherForm[k] = this.curriculumInfo[k];
      });
      if (this.curriculumInfo.level) this.levelValue = models.EvaluationLevel[this.curriculumInfo.level];
    }
  }

  onLevelConfirm(value) {
    this.levelValue = value;
    this.teacherForm.level = enumToObject(models.EvaluationLevel).find(e => e.label == value).value;
    this.showLevelPicker = false;
  }

  onBlur(val) {
    const num = val.target.value;
    if (num < 0 || num > 100) {
      Dialog.alert({
        message: '请输入0-100区间的数',
      });
    }
  }

  async onSubmit() {
    if (this.teacherForm.score < 0 || this.teacherForm.score > 100)
      Dialog.alert({
        message: '请输入0-100区间的数',
      });
    try {
      const { data, success, message } = await api.TeacherEvaluation.save_POST(this.teacherForm);
      if (success) {
        Dialog.alert({
          message: '评价成功',
        }).then(() => {
          this.$emit('courseCancel');
          // this.$router.push({
          //   name: 'myFeedbacks',
          //   params: { feedbackStatus: '教师评价' },
          // });
        });
        //评价成功，清空form
        for (let k of Object.keys(this.teacherForm)) {
          this.teacherForm[k] = null;
        }
        this.show = false;
      } else {
        Dialog.alert({
          message: '评价失败',
        });
      }
    } catch (err) {
      console.log(err);
    }
  }
}
